export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PartnerUriPatterns.vue?vue&type=template&id=31857327&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/partner/sections/PartnerUriPatterns.vue?vue&type=template&id=31857327&scoped=true&
// module id = 1576
// module chunks = 0